"use client";

import { c as _c } from "react/compiler-runtime";
import type { CicStatement } from "@/entities/IProfile";
import { useEffect, useState } from "react";
import PencilIcon from "@/components/utils/icons/PencilIcon";
import UserPageHeaderAboutStatement from "./UserPageHeaderAboutStatement";
import UserPageHeaderAboutEdit from "./UserPageHeaderAboutEdit";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
enum AboutStatementView {
  STATEMENT = "STATEMENT",
  EDIT = "EDIT",
}
export default function UserPageHeaderAbout(t0) {
  const $ = _c(22);
  const {
    profile,
    statement,
    canEdit
  } = t0;
  const [view, setView] = useState(AboutStatementView.STATEMENT);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setView(AboutStatementView.STATEMENT);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== canEdit || $[2] !== profile || $[3] !== statement) {
    t2 = [profile, statement, canEdit];
    $[1] = canEdit;
    $[2] = profile;
    $[3] = statement;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== view) {
    t3 = () => {
      if (view === AboutStatementView.STATEMENT) {
        setView(AboutStatementView.EDIT);
      } else {
        setView(AboutStatementView.STATEMENT);
      }
    };
    $[5] = view;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const toggleView = t3;
  let t4;
  if ($[7] !== toggleView || $[8] !== view) {
    t4 = () => {
      if (view === AboutStatementView.STATEMENT) {
        toggleView();
      }
    };
    $[7] = toggleView;
    $[8] = view;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const onEditClick = t4;
  let t5;
  if ($[10] !== canEdit || $[11] !== onEditClick || $[12] !== statement || $[13] !== view) {
    t5 = view === AboutStatementView.STATEMENT && <div className="tw-max-w-3xl"><div className={`tw-inline-flex tw-items-start tw-gap-2${canEdit ? " tw-group" : ""}`}>{canEdit ? <button type="button" onClick={onEditClick} aria-label={statement ? "Edit About statement" : "Add About statement"} className="tw-flex-1 tw-border-none tw-bg-transparent tw-p-0 tw-text-left"><UserPageHeaderAboutStatement statement={statement} /></button> : <UserPageHeaderAboutStatement statement={statement} />}{canEdit && <button type="button" onClick={onEditClick} aria-label={statement ? "Edit About statement" : "Add About statement"} className="tw-pointer-events-none tw-shrink-0 tw-border-none tw-bg-transparent tw-p-0 tw-text-iron-400 tw-opacity-0 tw-transition tw-duration-200 group-focus-within:tw-pointer-events-auto group-focus-within:tw-opacity-100 group-hover:tw-pointer-events-auto group-hover:tw-opacity-100 hover:tw-text-iron-200"><PencilIcon /></button>}</div></div>;
    $[10] = canEdit;
    $[11] = onEditClick;
    $[12] = statement;
    $[13] = view;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== profile || $[16] !== statement || $[17] !== view) {
    t6 = view === AboutStatementView.EDIT && <div><UserPageHeaderAboutEdit profile={profile} statement={statement} onClose={() => setView(AboutStatementView.STATEMENT)} /></div>;
    $[15] = profile;
    $[16] = statement;
    $[17] = view;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t5 || $[20] !== t6) {
    t7 = <div>{t5}{t6}</div>;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}